import { useAppDispatch } from '../../../redux-tool-kit/Hooks';
import { setDarkMode } from '../../../redux-tool-kit/reducers/LayoutSlice';
import { PropsColor } from '../../../types/layout/ThemeCustomizerTypes';
import { Form, FormGroup, Label, Row, Col, Button } from 'reactstrap';
import { Formik } from 'formik';
import UploadFile from './UploadFile';
import { useTranslation } from 'react-i18next';

export const radioData = [
  {
    text: "Big Logo",
  },
  {
    text: "Small Logo",
  },
  {
    text: "Favicon",
    defaultChecked: true,
  },
];

const ColorSection = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const initialValues: PropsColor = {
    primary: '#7366ff',
    secondary: '#f73164',
    tertiary: '#00c9b7',
    quaternary: '#ff9900',
    quinary: '#4b0082',
  };

  const handleColor = (data: PropsColor) => {
    dispatch(setDarkMode(false));
    document.documentElement.style.setProperty('--theme-default', data.primary);
    document.documentElement.style.setProperty('--theme-secondary', data.secondary);
    document.documentElement.style.setProperty('--theme-tertiary', data.tertiary);
    document.documentElement.style.setProperty('--theme-quaternary', data.quaternary);
    document.documentElement.style.setProperty('--theme-quinary', data.quinary);
  };

  return (
    <div className="p-3 flex flex-col md:flex-row gap-6">
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          handleColor(values);
          const payload = {
            primary: values.primary,
            secondary: values.secondary,
            tertiary: values.tertiary,
            quaternary: values.quaternary,
            quinary: values.quinary,
          };
          console.log('Color Payload:', payload);
          // Optionally dispatch payload to Redux or send to an API
          // dispatch(saveColors(payload));
        }}
      >
        {({ values, setFieldValue, handleSubmit }) => (
          <Form onSubmit={handleSubmit} className="w-full">
            <Row className="w-full">
              {/* Left Section: Color Pickers */}
              <Col md="4" className="mb-4">
              
                <Row>
                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label for="primaryColor">{t("PrimaryColor")}</Label>
                      <input
                        type="color"
                        id="primaryColor"
                        name="primary"
                        className="form-control form-control-color w-full"
                        value={values.primary}
                        onChange={(e) => setFieldValue('primary', e.target.value)}
                        title="Choose Primary Color"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label for="secondaryColor">{t("SecondaryColor")}</Label>
                      <input
                        type="color"
                        id="secondaryColor"
                        name="secondary"
                        className="form-control form-control-color w-full"
                        value={values.secondary}
                        onChange={(e) => setFieldValue('secondary', e.target.value)}
                        title="Choose Secondary Color"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label for="tertiaryColor">{t("TertiaryColor")}</Label>
                      <input
                        type="color"
                        id="tertiaryColor"
                        name="tertiary"
                        className="form-control form-control-color w-full"
                        value={values.tertiary}
                        onChange={(e) => setFieldValue('tertiary', e.target.value)}
                        title="Choose Tertiary Color"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label for="quaternaryColor">{t("QuaternaryColor")}</Label>
                      <input
                        type="color"
                        id="quaternaryColor"
                        name="quaternary"
                        className="form-control form-control-color w-full"
                        value={values.quaternary}
                        onChange={(e) => setFieldValue('quaternary', e.target.value)}
                        title="Choose Quaternary Color"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label for="quinaryColor">{t("QuinaryColor")}</Label>
                      <input
                        type="color"
                        id="quinaryColor"
                        name="quinary"
                        className="form-control form-control-color w-full"
                        value={values.quinary}
                        onChange={(e) => setFieldValue('quinary', e.target.value)}
                        title="Choose Quinary Color"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>

           
              <Col md="8" className="mb-4">
             
                <Row>
                
                  <Col sm="12">
                    <UploadFile label={t("OrganizationBigLogo")} />
                  </Col>
                  <Col sm="12">
                    <UploadFile label={t("OrganizationSmallLogo")} />
                  </Col>
                  <Col sm="12">
                    <UploadFile label={t("OrganizationFaviconLogo")} />
                  </Col>
                </Row>
              </Col>
            </Row>
          
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ColorSection;